import React from "react";
import { useTranslation } from "react-i18next";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { ServiceCard } from "@/components/cards/ServiceCard";
import { SERVICES } from "@/data/services";
import { useLocalize } from "@/data/localize";
import { SEO } from "@/lib/seo";

export default function ServicesPage() {
    const { t } = useTranslation();
    const { localizeList } = useLocalize();
    const services = localizeList(SERVICES);
    return (
        <>
            <SEO title={t("servicesPage.seoTitle")} description={t("servicesPage.seoDescription")} />
            <div className="container-page pt-8">
                <Breadcrumbs items={[{ label: t("servicesPage.seoTitle") }]} />
            </div>
            <section className="container-page pt-6 pb-4">
                <div className="max-w-3xl">
                    <span className="chip-teal">{t("servicesPage.chip")}</span>
                    <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--brand-navy)] leading-tight">
                        {t("servicesPage.title")}
                    </h1>
                    <p className="mt-4 text-[color:var(--text-muted)] leading-relaxed text-lg">
                        {t("servicesPage.intro")}
                    </p>
                </div>
            </section>
            <section className="container-page section-y">
                <div
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5"
                    data-testid="services-grid"
                >
                    {services.map((s) => (
                        <ServiceCard key={s.slug} service={s} />
                    ))}
                </div>
            </section>
        </>
    );
}
